const ON_CHANGE_DEBOUNCE_TIMER=300,PUB_SUB_EVENTS={cartUpdate:"cart-update",quantityUpdate:"quantity-update",variantChange:"variant-change",cartError:"cart-error"};
//# sourceMappingURL=/s/files/1/0896/0871/6634/t/11/assets/constants.js.map?v=1729506292
